import { scan } from "react-scan";
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { PrimeReactProvider } from "primereact/api";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import { router } from "./router.tsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import config from "./config.ts";

import * as Sentry from "@sentry/react";
import { initUserback } from "./services/userback/userbackClient";

scan({
  enabled: import.meta.env.VITE_REACT_SCAN_ENABLED === "true",
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: import.meta.env.PROD ? 0.5 : 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/is\.trakia-uni\.bg/],
  replaysSessionSampleRate: import.meta.env.PROD ? 0.25 : 0.1,
  replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 1.0,
  debug: import.meta.env.DEV,
  environment: import.meta.env.PROD ? "production" : "development",
});

const getUserData = () => {
  const email = localStorage.getItem("email") || "";
  const displayName = localStorage.getItem("displayName") || "";

  if (!email && !displayName) {
    return undefined;
  }

  return {
    user_data: {
      id: email || displayName || "anonymous",
      info: {
        name: email || "",
        email: email || "",
      },
    },
  };
};

const options = getUserData();

initUserback(options)
  .then((userback) => {
    console.log("Userback initialized successfully", userback);
  })
  .catch((error) => {
    console.error("Failed to initialize Userback:", error);
  });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PrimeReactProvider>
      <Provider store={store}>
        <Suspense fallback={<div>Loading...</div>}>
          <GoogleOAuthProvider clientId={config.googleClientId}>
            <RouterProvider router={router}></RouterProvider>
          </GoogleOAuthProvider>
        </Suspense>
      </Provider>
    </PrimeReactProvider>
  </React.StrictMode>,
);
